import React, { useState } from 'react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import { useTheme } from '@mui/material/styles';
import { MenuItem, Select, Typography } from '@mui/material';

const LanguageSelection = ({ blackColor }) => {
  const { i18n } = useTranslation();
  const theme = useTheme();

  const [lang, setLang] = useState(i18n?.language?.toUpperCase());

  const handleLanguageChange = e => {
    setLang(e.target.value);
    i18n.changeLanguage(e.target.value?.toLowerCase());
    dayjs.locale(e.target.value?.toLowerCase());
  };

  return (
    <Select
      id='language-selector'
      value={lang}
      onChange={handleLanguageChange}
      variant='standard'
      disableUnderline
      sx={{
        color: blackColor ? `${theme.palette.black[900]}` : `${theme.palette.white[100]}`,
        '.MuiSvgIcon-root': blackColor ? { color: `${theme.palette.black[900]}` } : { color: `${theme.palette.white[100]}` },
      }}>
      <MenuItem value='AR'>
        <Typography variant='text' textAlign='center' sx={{ fontFamily: 'CalibriArabic' }}>
          ع
        </Typography>
      </MenuItem>
      <MenuItem value='EN'>
        <Typography variant='text' textAlign='center' sx={{ fontFamily: 'Inter' }}>
          EN
        </Typography>
      </MenuItem>
    </Select>
  );
};

export default LanguageSelection;
